__turbopack_context__.v({
  "className": "inter_306fc1a4-module__1yr7nq__className",
  "variable": "inter_306fc1a4-module__1yr7nq__variable",
});
